import { IFileUploadStatus } from '@/models/fileUpload';
import { CheckIcon } from '@heroicons/react/solid';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { UploadingFile } from '../FileDataSourceProgressBar/UploadingFile';
import { Button } from '@/components/buttons';

type UploadOngoing = {
  fileUpload: IFileUploadStatus;
  filename: string;
  onClick: () => void;
};

export const UploadingOngoing: FC<UploadOngoing> = ({ fileUpload, filename, onClick }) => {
  const { t } = useTranslation('data_source_edit');

  return (
    <div className='flex flex-col items-center justify-center gap-3 text-center'>
      <span className='flex size-10 items-center justify-center rounded-full bg-green-600'>
        <CheckIcon className='size-6 text-white-100' aria-hidden='true' />
      </span>
      <h3 className='text-lg font-medium text-gray-900'>{t('file.confirmation.all_columns_are_mapped')}</h3>
      <p className='w-2/3 text-base font-normal text-gray-900'>{t('file.confirmation.all_columns_are_mapped_description')}</p>
      <div className='mt-6 flex w-2/3 flex-col gap-9 rounded-sm border border-gray-300 bg-gray-50 p-5'>
        <p className='text-sm font-normal text-gray-900'>{t('file.confirmation.continue_working')}</p>
        <UploadingFile fileUpload={fileUpload} filename={filename} />
      </div>
      <div className='flex w-2/3 justify-end'>
        <Button variant='confirm' onClick={onClick}>
          {t('file.confirmation.continue_in_background')}
        </Button>
      </div>
    </div>
  );
};
